import { graphql, useStaticQuery } from "gatsby"

export const useSiteMetadata = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
            title
            description
            email
            telephone
            author
            siteUrl
            defaultImage
        }
      }
    }
  `)

  return data.site.siteMetadata
}